import {useEffect, useState} from "react";
import {UserService} from "./Service";
import toast from "react-hot-toast";
import {useParams} from "react-router";
import CreateOrder from "../order/CreateOrder";
import ManageCards from "./ManageCards";

const EditUser = () => {
    const { id } = useParams();
    const [userService] = useState(new UserService()); // [state, setState
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState(null);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);

    // Generate a random password
    const generatePassword = () => {
        const length = 8;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let retVal = "";
        for (let i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        setPassword(retVal);
    }

    const getDetail = async () => {
        const res = await userService.get(id);
        if (res) {
            setName(res.name);
            setEmail(res.email);
        }
    }

    const sendInvitation = async () => {
        toast.loading("Sending invitation...");
        const res = await userService.sendCredentials(id);
        toast.dismiss();
        if (res) {
            toast.success("Invitation sent successfully", {});
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const data = {
            name,
            email,
            ...(password && {password})
        };
        const res = await userService.update(id, data);
        if (res) {
            setLoading(false);
            toast.success("User updated successfully", {});
        }
    }

    useEffect(() => {
        getDetail();
    }, [id]);



    return (
        <>
            <div className="card mb-5">
                <div className="card-header p-3 d-flex justify-content-between">
                    <h5 className="card-title">Edit User</h5>
                    <button type="button" className="btn btn-primary btn-sm" onClick={sendInvitation}>Send Invitation</button>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Full Name <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="name" name="name" placeholder="Name" value={name}
                                           onChange={(e) => setName(e.target.value)} required={true}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Email <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="email" className="form-control" id="email" name="email" placeholder="Email" value={email}
                                           onChange={(e) => setEmail(e.target.value)} required={true}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Password <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="password" name="password" placeholder="Password" value={password}
                                           onChange={(e) => setPassword(e.target.value)}/>
                                </div>
                            </div>

                        </div>

                        <div className={'d-flex'}>
                            <button type="submit" className="btn btn-primary me-2" disabled={loading}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Submit
                            </button>
                            <button type="button" className="btn btn-secondary me-2" disabled={loading} onClick={() => {
                                window.history.back();
                            }}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Back
                            </button>
                        </div>

                    </form>

                </div>
            </div>

            <CreateOrder user={id} refresh={
                () => {
                    // Render ManageChains component again
                    setRefresh(!refresh);
                }
            } />
            <ManageCards user={id} refresh={refresh} />
        </>
    );
}


export default EditUser;
